export const stuckedTransactionConfig = {
    STUCKED_TRANSACTION_PRODUCT_UPLOAD_TYPE:1,
    STUCKED_TRANSACTION_INVENTORY_UPLOAD_TYPE:2,
    STUCKED_TRANSACTION_IMAGE_UPLOAD_TYPE:3,
    STUCKED_TRANSACTION_FILE_STATUS:0
};
